
interface MapMarkerContentContainerProps {
    style: any,
    isSelected?: boolean,
    highlight?: boolean,
    onMouseEnter: () => void,
    onMouseLeave: () => void,
}
export const MapMarkerContentContainer = ({
    children,
    style,
    isSelected = false,
    highlight = false,
    onMouseEnter,
    onMouseLeave,
}: PropsWithChildren<MapMarkerContentContainerProps>) => {
    return (
        <div
            className={`gm-marker-c ${isSelected ? 'gm-marker-c-selected' : ''} ${highlight ? 'gm-marker-c-highlight' : ''}`}
            style={style}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}>
            <div/>
            <div style={{ padding: 10, zIndex: 10 } }>
                {children}
            </div>
        </div>
    )
}
